type WidthType = 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'small' | 'dialog' | 'auto' | number;

// get the width class of a textField if a predefined width is used
export const getWidthClass = (width: WidthType) => {
  if (typeof width !== 'number') {
    switch (width) {
      case 'xxlarge':
        return '--width-xxlarge';
      case 'xlarge':
        return '--width-xlarge';
      case 'large':
        return '--width-large';
      case 'medium':
        return '--width-medium';
      case 'small':
        return '--width-small';
      case 'dialog':
        return '--width-dialog';
      case 'auto':
        return '--width-auto';
    }
  }
  return '';
};

// get the width style of a textField if a numeric value is used
export const getWidthStyle = (width: WidthType) =>
  typeof width === 'number' ? { width: `${width}px` } : {};
